// extracted by mini-css-extract-plugin
export default {"statuses":"style_statuses__2iD11"};